import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { color } from './color';
import { enumItems } from './enumItems';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPSelectIconField } from '../components/Table/fields/SPSelectIconField';

const makeStatus = (
  name: string,
  url: string,
  show: boolean
): SchemaWithClient<any> => ({
  name: `${name} Status`,
  pluralName: `${name} Statuses`,
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  show: show,
  columns: {
    name: {
      name: 'Label',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    color: {
      name: 'Color',
      fieldRenderer: SelectField.tableAdapter(color),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(color),
      switchboard: true,
      url: color.client.getAllPath,
      tempSchema: color,
    },
    icon: {
      name: 'Icon',
      fieldRenderer: SelectField.tableAdapter(enumItems.icon),
      slidePaneFieldRenderer: SPSelectIconField.tableAdapter(enumItems.icon),
      switchboard: true,
      url: enumItems.icon.client.getAllPath,
      tempSchema: enumItems.icon,
    },
    end_status: {
      name: 'End Status',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    booked_end_status: {
      name: 'Booked End Status',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    active: {
      name: 'Active',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    /*  sent: {
      name: 'Sent',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },*/
    /* denied: {
      name: 'Denied',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },*/
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/statuses' + url),
});

export const statuses = {
  guide: makeStatus('Guide', '/guide', true),
  group: makeStatus('Group', '/group', true),
  program_status: makeStatus('ProgramStatus', '/program_status', false),
  activityStatus: makeStatus('Activity', '/activity-status', true),
  bus: makeStatus('Bus', '/bus', false),
  stripper: makeStatus('Stripper', '/stripper', false),
  booking: makeStatus('Accommodation Reservation', '/booking', false),
  serviceProvider: makeStatus(
    'Service Provider',
    '/service-provider-status',
    false
  ),
  guideCostStatus: makeStatus('Guide Cost', '/guide-cost-status', false),
  reservationStatus: makeStatus(
    'A-B-S',
    '/reservation-status',
    true
  ),
  stripperReservationStatus: makeStatus(
    'Artist Reservation',
    '/stripper-reservation-status',
    false
  ),
  reservationCostStatus: makeStatus(
    'Reservation Cost',
    '/reservation-cost-status',
    false
  ),
  activityReservationCostStatus: makeStatus(
    'Reservation Cost Status',
    '/activity-reservation-cost-status',
    false
  ),
  serviceSeStatus: makeStatus('Service Se', '/service-se-status', false),
  serviceSpStatus: makeStatus('Service Sp', '/service-sp-status', false),
  serviceReservationStatus: makeStatus(
    'Service Reservation',
    '/service-reservation-status',
    true
  ),
  accommodationReservationStatus: makeStatus(
    'Accommodation Reservation',
    '/accommodation-reservation-status',
    true
  ),
};
